export const PROPERTY_TYPE_ICON_KEY = Object.freeze({
  ANNUALDATE: 'event',
  BOOLEAN: 'check_box',
  CHECKLIST: 'checklist',
  COLOR: 'palette',
  ICON: 'interests',
  COVER: 'image',
  CURRENCY: 'attach_money',
  DATE: 'calendar_today',
  DATERANGE: 'calendar_today',
  DATETIME: 'calendar_today',
  DATETIMERANGE: 'calendar_today',
  DATES: 'calendar_today',
  DESCRIPTION: 'text_fields',
  EMAIL: 'mail',
  ENUM: 'format_list_bulleted',
  LOCATION: 'place',
  MULTISELECT: 'checklist',
  NUMBER: 'tag',
  NODELIST: 'format_list_bulleted',
  PERCENTAGE: 'percent',
  PEOPLE: 'group',
  PHONE: 'call',
  PROFILE: 'person',
  PROFILE_LIST: 'group',
  STRING: 'text_fields',
  TAGS: 'style',
  TEXT: 'notes',
  URL: 'link',
});

function normalizeFieldType(type) {
  return String(type || '').trim().toUpperCase();
}

export function getFieldTypeIconKey(type, fallback = 'deployed_code') {
  const normalizedType = normalizeFieldType(type);
  if (!normalizedType) return fallback;

  return PROPERTY_TYPE_ICON_KEY[normalizedType] || fallback;
}
